import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as utils from '../common/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['../../global.scss']
})

export class ConfirmBoxComponent {
  title: string = 'CONFIRMATION';
  message: string = 'TBD';
  noTitle: string = '';
  yesTitle: string = 'Yes';

  constructor(public dialogRef: MatDialogRef<ConfirmBoxComponent>,
              @Inject(MAT_DIALOG_DATA) data: any,
              private translateService: TranslateService)
  {
    // this.translateService.get('MESSAGEBOX').subscribe((translated: string) => 
    // {
    //   this.title = translated['TITLE'];
    //   this.message = translated['MESSAGE'];
    //   this.yesTitle = translated['YES_TITLE'];
    //   this.noTitle = translated['NO_TITLE'];
    // });

    if (typeof data.title != 'undefined')
      this.title = data.title;
    if (typeof data.message != 'undefined')
      this.message = data.message;
    if (typeof data.yesTitle != 'undefined')
      this.yesTitle = data.yesTitle;
    if (typeof data.noTitle != 'undefined')
      this.noTitle = data.noTitle;
  }

  static createDialogConfig(message: string, title: string, yesTitle: string, noTitle: string) {
    const dialogConfig = utils.createDialogConfig(false, true);
    dialogConfig.position = undefined; // to be placed in the center
    dialogConfig.data = { message: message, title: title, yesTitle: yesTitle, noTitle: noTitle };
    return dialogConfig;
  }
}
